import * as React from 'react';
import { observer } from 'mobx-react';
import { DemandPosition } from '../../stores';
import { Table, Tab } from 'react-bootstrap';
import { formatMoney, formatShortDate } from '../../common/Formatting';

interface IProps {
    data: any;
}

interface IFormData {
    demandNumber: string;
    sellerName: string;
    customerName: string;
    customerPhone: string;
    positions: DemandPosition[]
}

@observer
export class DemandForm extends React.Component<IProps, {}> {
    private formData = this.props.data as IFormData;
    private totalSum = formatMoney(this.formData.positions.reduce((a: number, b) => a + (b.costSale * b.count), 0));
    public render() {
        return <div>
            <div>
                <h3 style={{ borderBottom: "2px solid black" }}>Расходная накладная № {this.formData.demandNumber} от {formatShortDate(new Date())}</h3>
            </div>
            <br />
            <br />
            <table>
                <tr>
                    <td style={{ width: "150px" }}>Поставщик</td>
                    <td>
                        <strong><div>ООО Абтека</div></strong>
                    </td>
                </tr>
                <tr>
                    <td>Покупатель</td>
                    <td>
                        <strong>
                            <div>{this.formData.customerName}</div>
                            <div>тел.: {this.formData.customerPhone}</div>
                        </strong>
                    </td>
                </tr>
            </table>
            <br />
            <Table bordered>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Номер заказа</th>
                        <th>Артикул</th>
                        <th>Производитель</th>
                        <th>Наименование</th>
                        <th>Количество</th>
                        <th>Цена</th>
                        <th>Сумма</th>
                    </tr>
                </thead>
                <tbody>
                    {this.formData.positions.map((item, index) => <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.orderNumber}</td>
                        <td>{item.article}</td>
                        <td>{item.brand}</td>
                        <td>{item.description}</td>
                        <td>{item.count}</td>
                        <td>{formatMoney(item.costSale)}</td>
                        <td>{formatMoney(item.count * item.costSale)}</td>
                    </tr>)}
                </tbody>
            </Table>
            <div className="text-right">
                <strong>{this.totalSum}</strong>
            </div>
            <br />
            <br />
            <div>
                <strong> Всего наименований {this.formData.positions.length}, на сумму {this.totalSum} RUB</strong>
            </div>
            <div>
                <br />
                <br />
                <table style={{ width: "100%" }}>
                    <tr>
                        <td style={{ width: "350px" }}>
                            <h3>Всего мест получил</h3>
                        </td>
                        <td>
                            <br />
                            <div style={{ borderTop: "1px solid black", textAlign: "center" }}>(прописью)</div>
                        </td>
                    </tr>
                </table>
                <br />
                <br />
                <div style={{ borderBottom: "2px solid black" }}></div>
                <br />
                <br />
                <table style={{ width: "100%" }}>
                    <tr>
                        <td style={{ width: "50%", textAlign: "left", borderBottom: "1px solid black" }}>
                            Отпустил
                        </td>
                        <td style={{ width: "50%", textAlign: "left", borderBottom: "1px solid black" }}>
                            Получил
                        </td>
                    </tr>
                </table>
            </div>
        </div>;
    }
}
